export enum LocalizationEnum {
  None = 0,
  MK = 1,
  RS = 2,
  EN = 3,
}

export interface BlogCreateDto {
  title: string;
  excerpt: string;
  content: string;
  mainImage?: string;
  isPublished: boolean;
  localization: LocalizationEnum;
}

export interface BlogUpdateDto {
  title: string;
  excerpt: string;
  content: string;
  mainImage?: string;
  isPublished: boolean;
  localization: LocalizationEnum;
}

export interface BlogResponseDto {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  mainImage?: string;
  mainImageUrl: string;
  dateModified: string; 
  isPublished: boolean;
  localization: LocalizationEnum;
}